import Joi from 'joi';

import { TagRecordCategoryEnum } from '../../enums/tag-record-category.enum';

/**
 * Schema for tags validation on parent create/update payloads.
 */
export const createTagsSchema = () =>
  Joi.array()
    .items(
      Joi.object({
        id: Joi.number().optional().messages({
          'number.base': 'validations|tag-id|must-be-number',
        }),
        name: Joi.string()
          .when('id', {
            is: Joi.exist(),
            then: Joi.required(),
            otherwise: Joi.optional(),
          })
          .messages({
            'any.required': 'validations|tag-name|required',
          }),
        recordCategory: Joi.string()
          .valid(...Object.values(TagRecordCategoryEnum))
          .required()
          .messages({
            'any.required': 'validations|tag-record-category|required',
            'any.only': 'validations|tag-record-category|invalid-value',
          }),
        description: Joi.string().allow(null, ''),
        color: Joi.string().allow(null, ''),
      }).unknown(),
    )
    .allow(null);
